module.exports = __webpack_public_path__ + "img/experian.c5510d5d.svg";